class PageBannerVideo extends HTMLElement {
  connectedCallback() {
    if (this.#initialised) return;
    this.#initialised = true;

    const hasSource = this.dataset.youtubeUrl || this.dataset.videoSrc;
    if (!hasSource) return;

    this.#setYouTubePoster();

    const play = this.querySelector('.custom-page-banner__play');
    if (!play) return;

    play.addEventListener('click', () => this.#play());
  }

  #initialised = false;
  #playing = false;

  #setYouTubePoster() {
    const url = this.dataset.youtubeUrl;
    if (!url) return;

    const poster = this.querySelector('.custom-page-banner__poster');
    if (poster && poster.tagName === 'IMG') return;

    const id = this.#youtubeId(url);
    if (!id) return;

    const img = document.createElement('img');
    img.className = 'custom-page-banner__poster';
    const fallback = `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
    img.onerror = function () {
      this.onerror = null;
      this.src = fallback;
    };
    img.onload = function () {
      if (this.naturalWidth <= 120) {
        this.onload = null;
        this.src = fallback;
      }
    };
    img.src = `https://img.youtube.com/vi/${id}/maxresdefault.jpg`;
    img.alt = this.querySelector('.custom-page-banner__play')?.getAttribute('aria-label') || 'Video';
    img.loading = 'eager';

    if (poster) poster.replaceWith(img);
    else this.prepend(img);
  }

  #youtubeId(url) {
    const match = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/|live\/)|youtu\.be\/)([\w-]{11})/);
    return match ? match[1] : null;
  }

  #play() {
    if (this.#playing) return;

    const youtubeUrl = this.dataset.youtubeUrl;
    let media;

    if (youtubeUrl) {
      const id = this.#youtubeId(youtubeUrl);
      if (!id) return;
      media = document.createElement('iframe');
      media.className = 'custom-page-banner__video-player';
      media.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&playsinline=1&modestbranding=1`;
      media.tabIndex = 0;
      media.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
      media.setAttribute('allowfullscreen', '');
      media.setAttribute('title', this.querySelector('.custom-page-banner__play')?.getAttribute('aria-label') || 'Video');
      media.setAttribute('frameborder', '0');
    } else {
      const src = this.dataset.videoSrc;
      if (!src) return;
      media = document.createElement('video');
      media.className = 'custom-page-banner__video-player';
      media.controls = true;
      media.autoplay = true;
      media.playsInline = true;
      media.preload = 'metadata';

      const source = document.createElement('source');
      source.src = src;
      source.type = this.dataset.videoMime || 'video/mp4';
      media.appendChild(source);
    }

    this.#playing = true;
    this.appendChild(media);

    const play = this.querySelector('.custom-page-banner__play');
    if (play) play.hidden = true;

    const poster = this.querySelector('.custom-page-banner__poster');
    if (poster) poster.hidden = true;

    this.style.cursor = 'default';
    media.focus();
  }
}

if (!customElements.get('page-banner-video')) {
  customElements.define('page-banner-video', PageBannerVideo);
}
